/* Zendia · Blog landing — selettori accessibili, tab automatiche, reveal leggero. Nessuna dipendenza. */
(function () {
  function initTabs(root) {
    if (root.classList.contains('is-ready')) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    var start = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    root.classList.add('is-ready');
    select(start, false);
  }

  /* Trasforma un gruppo di card del corpo articolo in tab, usando il <small> di ogni card come etichetta */
  function autoTabs(box, uid) {
    var cards = Array.prototype.slice.call(box.children);
    if (cards.length < 2) return;
    var list = document.createElement('div');
    list.className = 'zbl-tabs__list';
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-label', box.getAttribute('data-zbl-autotabs') || 'Seleziona');
    cards.forEach(function (c, i) {
      var lab = c.querySelector('small');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zbl-tab';
      b.setAttribute('role', 'tab');
      b.id = uid + '-t' + i;
      b.setAttribute('aria-controls', uid + '-p' + i);
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.textContent = lab ? lab.textContent.trim() : 'Opzione ' + (i + 1);
      list.appendChild(b);
      c.id = uid + '-p' + i;
      c.setAttribute('role', 'tabpanel');
      c.setAttribute('aria-labelledby', b.id);
      c.classList.add('zbl-tabs__panel');
    });
    box.classList.add('zbl-tabs');
    box.style.display = 'block';
    box.insertBefore(list, box.firstChild);
    initTabs(box);
  }

  function reveal(root) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = root.querySelectorAll('.zx-sec .zx-box, .zx-sec .zx-conv, .zbl-rv');
    root.classList.add('is-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('zbl-rv');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.zbl'), function (root, n) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-zbl-autotabs]'), function (box, i) { autoTabs(box, 'zbl' + n + 'a' + i); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-zbl-tabs]'), initTabs);
      reveal(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();